<script setup>
import {Head, Link, usePage} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import HeroIcon from '@/Shared/HeroIcon.vue'
import {ref, defineProps} from 'vue'
import {Inertia} from '@inertiajs/inertia'
import axios from 'axios'
import FlashMessages from '@/Shared/FlashMessages'

const props = defineProps({
  auth: Object,
  user_id: String,
})

const openPw = ref( false)
const openPwConfirm = ref( false)

const form = ref({
  password: '',
  password_confirmation: '',
})
const generateNewPw = function (){
  axios.get("/generateNewPassword").then((response) => {
    form.value.password = response.data
    form.value.password_confirmation = response.data
    openPw.value = true
    openPwConfirm.value = true
  })
}

const store = function () {
  Inertia.post(`/user/` + props.user_id + '/changePassword', form.value)
}
</script>
<template>
  <Head title="Passwort Änderung"/>
  <div class="flex items-center relative justify-center p-6 min-h-screen bg-orfBlue-800">
    <div class="w-full max-w-sm">
      <img class="mx-auto" src="/img/Enterprise_quer_4C_HG%20blau.png" width="120"/>
      <form class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="store">
        <div class="px-10 py-8 relative">
          <h1 class="text-center text-3xl font-bold">Office Tool</h1>
          <h2 class="text-center my-2">Passwort Änderung</h2>
          <div class="mt-3 mb-6 mx-auto w-full border-b-2"/>
          <div class="flex flex-col gap-4">
            <div class="relative">
              <HeroIcon :name="openPw ? 'eye-slash' : 'eye'" class="absolute top-10 transform -translate-y-0.5 right-4 z-40 hover:fill-orfBlue-100 cursor-pointer w-4 h-4" @click="openPw = !openPw"/>
              <text-input v-if="openPw" v-model="form.password" name="password"
                          type="text" autocomplete="new-password" label="Passwort"
              />
              <text-input v-else v-model="form.password" name="password"
                          type="password" autocomplete="new-password" label="Passwort"
              />
              <div @click="generateNewPw" class="absolute -top-0.5 right-0 text-xs bg-green-500 rounded-full hover:bg-green-700 cursor-pointer duration-300 text-white px-2 py-0.5">
                Passwort generieren
              </div>
              <div v-if="$page.props.errors.password" class="form-error">{{ $page.props.errors.password }}</div>
            </div>
            <div class="relative">
              <HeroIcon :name="openPwConfirm ? 'eye-slash' : 'eye'" class="absolute top-10 transform -translate-y-0.5 right-4 z-40 hover:fill-orfBlue-100 cursor-pointer w-4 h-4" @click="openPwConfirm = !openPwConfirm"/>
              <text-input v-if="openPwConfirm" v-model="form.password_confirmation" name="password_confirmation"
                         type="text" autocomplete="new-password" label="Passwort bestätigen"
              />
              <text-input v-else v-model="form.password_confirmation" name="password_confirmation"
                         type="password" autocomplete="new-password" label="Passwort bestätigen"
              />
            </div>
            <div v-if="$page.props.errors.password_confirmation" class="form-error">{{ $page.props.errors.password_confirmation }}</div>
          </div>
        </div>
        <div class="flex justify-center px-10 py-4 bg-gray-100 border-t border-gray-100">
          <loading-button :loading="form.processing" text="Bestätigen" icon-name="save" icon-custom-icon/>
        </div>
      </form>
    </div>
  </div>
</template>
